{
    "features-majority-account-no-fees": {
        "breadcrumbs": "Sin cargos ocultos",
        "meta": {
            "title": "Una App con protección financiera y sin cargos bancarios - MAJORITY",
            "description": "Descubre la mejor aplicación de membresía y protección financiera sin cargos bancarios ocultos. ¡Deja de pagar cargos excesivos por sobregiros y saldo mínimo."
        },
        "hero": {
            "title": "La mejor protección financiera que no te deja sobregirar tu cuenta",
            "body": "La mejor protección financiera que no te deja sobregirar tu cuenta. ¡Ahorra hasta $35/mes* sin cargos por sobregiro!",
            "disclaimer": "*Según datos de la Oficina para la Protección Financiera del Consumidor",
            "cta": "Comenzar"
        },
        "overdraft_content_box": {
            "tagline": "Cuenta de MAJORITY",
            "title": "La mejor manera de evitar los cargos bancarios por sobregiro",
            "body": "Es sencillo. La mejor manera de evitar los cargos bancarios por sobregiro es registrarte en una cuenta que no los cobre. A diferencia de muchos bancos tradicionales, no tenemos cargos bancarios por sobregiro. El motivo es que no creemos que sea justo dejarte sobregirar tu cuenta y luego cobrarte.",
            "cta": "Comenzar",
            "canvas": "Ahorra hasta $35/mes"
        },
        "no_fees_content_box": {
            "tagline": "Cuenta de MAJORITY",
            "title": "No más cargos ocultos",
            "body": "Disfruta de la protección financiera que te mereces, además de no cobrar cargos por sobregiro, tampoco tenemos cargos por saldo mínimo. Ya sea que tengas $1 o $1,000 en tu cuenta, no te cobraremos ningún cargo oculto. Después de todo, es tu dinero, así que puedes mantener la cantidad que desees en tu cuenta.",
            "cta": "Comenzar"
        },
        "compare_fees_content_box": {
            "tagline": "Cuenta de MAJORITY",
            "title": "Compara los cargos",
            "body": "Cuando se trata de cargos ocultos, MAJORITY no tiene ninguno.",
            "fee_0": "Cargos bancarios por sobregiro",
            "fee_1": "Depósito de apertura",
            "fee_2": "Cargo por saldo mínimo",
            "fee_3": "Cargos por transacción en el extranjero"
        },
        "spend_anywhere_box": {
            "tagline": "Cuenta de MAJORITY",
            "title": "Gasta en cualquier parte del mundo sin cargos bancarios extra",
            "body": "El dinero no conoce fronteras, así que los costos por transacciones al extranjero no tienen sentido. Donde sea que estés, puedes usar tu tarjeta de débito MAJORITY Visa® sin pagar cargos bancarios por transacciones en el extranjero. Ya sea que utilices tu tarjeta en el extranjero o en tiendas en línea internacionales, no tienes que pagar cargos extra.",
            "cta": "Comenzar",
            "canvas": "¡Ahorra sin esfuerzo!"
        }
    }
    
}